import { render } from "./DistrictListComponent.vue?vue&type=template&id=4dc1a382"
import script from "./DistrictListComponent.vue?vue&type=script&lang=js"
export * from "./DistrictListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__